<mat-accordion *ngIf="showToolbar">
  <mat-expansion-panel class="lv-entwicklerleiste-expansion-panel" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon fontIcon="fa-times" (click)="showToolbar = false"></mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="lv-top-row">
      <div class="lv-entwicklerleiste-left">
        <p><strong>Systeminformationen:</strong></p>
        <p>Environment: {{ env?.environment?.name }}</p>
        <p>Lives-Api URL: {{ env?.host_lives_api?.url }}</p>
        <p>Antragserfassung URL: {{ _uiConfigService.getAntragserfassungUrl() }}</p>
        <hr/>
        <p><strong>Testeinstellungen:</strong></p>
        <mat-checkbox class="lv-entwicklerleiste-checkbox" name="smsDoi" [(ngModel)]="smsDoi">smsDoi</mat-checkbox>
        <mat-checkbox class="lv-entwicklerleiste-checkbox" name="emailDoi" [(ngModel)]="emailDoi">emailDoi</mat-checkbox>
        <mat-checkbox class="lv-entwicklerleiste-checkbox" name="bonitaet" [(ngModel)]="bonitaet">Bonität</mat-checkbox>
        <mat-checkbox class="lv-entwicklerleiste-checkbox" name="compliance" [(ngModel)]="compliance">Compliance</mat-checkbox>
        <hr/>
        <p><strong>Lives-Core API Informationen:</strong></p>
        Angebotserstellung m&ouml;glich: {{angebotserstellungMoeglichJN$ | async | jaNein}}
      </div>
      <div class="lv-entwicklerleiste-middle">
        <div class="lv-entwicklerleiste-flex-col">
          <div class="lv-entwicklerleiste-inputs">
            <div class="lv-entwicklerleiste-flex-col">
              <label
                  class="lv-label">Versicherungsnummer</label>
              <lv-material-form-input [(ngModel)]="vnr"
                                      #versicherungsnummer="ngModel"
                                      name="versicherungsnummer"
                                      [disabled]="!!defId"
                                      [placeholder]="'8-stellig'"></lv-material-form-input>
              <label>Antragsgeneration Datum</label>
              <mat-form-field>
                <div class="lv-input-field">
                  <input cypress-uuid="antragsgenerationDatum" matInput [matDatepicker]="picker" [(ngModel)]="antragsgenerationDatum">
                </div>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="lv-entwicklerleiste-flex-col">
              <label
                  class="lv-label">ProduktId</label>
              <div class="lv-flex">
                <mat-form-field cypress-uuid="produktIdDropdown" >
                  <input matInput type="text" name="produktId" [disabled]="!!vnr" [(ngModel)]="defId" [matAutocomplete]="autoProduktId">
                  <mat-autocomplete  [hideSingleSelectionIndicator]="true" autoActiveFirstOption #autoProduktId="matAutocomplete"
                                    (optionSelected)="setProdukt($event.option.value)" [panelWidth]="'fit-content'">
                    <mat-option *ngFor="let produkt of getProdukteFiltered()" [value]="produkt">
                      {{produkt}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <label
                  class="lv-label">UIVorgangID</label>
              <mat-form-field>
                <mat-select [hideSingleSelectionIndicator]="true" name="testdata" [(ngModel)]="uiVorgangId">
                  <mat-option *ngFor="let uiVorgangId of uiVorgangIds" [value]="uiVorgangId">{{uiVorgangId}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <label
                  class="lv-label">KollektivId</label>
              <lv-material-form-input [(ngModel)]="kollektivId"
                                      #kollektivid="ngModel"
                                      name="kollektivid"
              ></lv-material-form-input>
            </div>
          </div>
          <div class="lv-entwicklerleiste-url-button">
            <button mat-raised-button color="primary" cypress-uuid="reloadButton" (click)="reloadLivesApiWithParams()"
                    [disabled]="!vnr && !defId">
              Reload mit URL Parameter
            </button>
          </div>
        </div>
        <div class="lv-messages">
          <ng-container *ngIf="errorMessages | async as errors">
            <div class="lv-error-messages" *ngIf="errors.length">
              <div class="lv-flex-end">
                <mat-icon fontIcon="fa-times" (click)="clearErrors()"></mat-icon>
              </div>
              <div class="lv-message" *ngFor="let message of errors">
                &rarr; {{message}}
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="warningMessages | async as warnings">
            <div class="lv-warning-messages" *ngIf="warnings.length">
              <div class="lv-flex-end">
                <mat-icon fontIcon="fa-times" (click)="clearWarnings()"></mat-icon>
              </div>
              <div class="lv-message" *ngFor="let message of warnings">
                &rarr; {{message}}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="lv-entwicklerleiste-right">
        <div class="lv-on-reload-spinner" *ngIf="isLoading">
          <mat-progress-spinner [color]="'accent'" mode="indeterminate"
                                [diameter]="70"></mat-progress-spinner>
        </div>
        <div *ngIf="env?.environment?.name === 'Develop'" class="lv-entwicklerleiste-reload-buttons">
          <button mat-raised-button color="primary" (click)="reloadLivesApi()">
            Reload Lives-Api
          </button>
          <button mat-raised-button color="primary" (click)="reloadLivesApiAndPage()">
            Reload Lives-Api und Seite
          </button>
        </div>
        <div class="lv-entwicklerleiste-success-message"
             *ngIf="successMessage">{{successMessage}}</div>
        <mat-form-field>
          <mat-select [hideSingleSelectionIndicator]="true" name="testdata" [(ngModel)]="testdata">
            <mat-option *ngFor="let data of testdata$ | async" [value]="data">{{data}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-raised-button color="primary" cypress-uuid="autofillButton" (click)="autofill()">
          Autofill
        </button>
        <button mat-raised-button color="primary" (click)="copyJsonToClipboard()">
          {{copied ? 'Copied' : 'Copy JSON To Clipboard'}}
        </button>
        <button mat-raised-button color="primary" (click)="copyCoreJsonToClipboard()">
          {{copiedCore ? 'Copied' : 'Copy Core-JSON To Clipboard'}}
        </button>
        <button mat-raised-button color="primary" (click)="validate()">
          Validieren
        </button>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
